import styled from 'styled-components'
// themes
import { colors } from 'themes'

export const Container = styled.div`
  margin-top: 24px;
  display: flex;
  gap: 16px;
  justify-content: flex-end;
`

export const LoaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 24px;
  padding: 24px 0;
  width: 100%;
`

export const GeneratingText = styled.span`
  font-size: 13px;
  color: ${colors.gray380};
  min-height: 20px;
  transition: opacity 0.4s ease;
  font-weight: 500;
`
